/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getEnrichedPlaidData} from '../api'

 export const useQueryGetEnrichedPlaidData = createReactQueryHook('getEnrichedPlaidData', getEnrichedPlaidData)
